import { HttpParams } from '@angular/common/http';

/**
 * Convierte un objeto de filtros/paginación en `HttpParams`, omitiendo valores
 * vacíos (`undefined`, `null`, `''`). Las claves se usan tal cual, así que el
 * caller las pasa en el nombre que espera el backend (snake_case).
 */
export function toHttpParams(query: Record<string, unknown> | undefined): HttpParams {
  let params = new HttpParams();
  if (!query) return params;
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null || value === '') continue;
    params = params.set(key, String(value));
  }
  return params;
}
